import * as Long from "long";
import { from } from "rxjs";
import { selectCoopMaxLevel } from "../../../balancingSelectors/selectBalancingXpLevels";
import { IdPersistence } from "../../../constants/IdPersistence";
import { selectCoopLevelFromXp } from "../../../selectors/selectCoopInfo";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { PlayerPreferencesPlatformType, } from "../../../utils/network/generated/protoTypes";
import { utilPersistence } from "../../../utils/utilPersistence";
import { actionCoopInfoReceived, actionCoopMemberRequest } from "../../cooperative/actionCoop";
import { actionServerPersistenceSetInfo } from "../../server-persistence/actionServerPersistence";
export var networkNoticeCoopInfoHandler = function (action$, state$, deps) { return function (res) {
    var actions = [actionCoopInfoReceived(res)];
    if (res.coop && res.coop.id && Long.NEG_ONE.lessThan(res.coop.id)) {
        actions.push(actionCoopMemberRequest(selectPlayerInfo(state$.value).playerId, res.coop.id));
    }
    var state = state$.value;
    var coopId = selectPlayerInfo(state).coopId;
    var storedLevel = utilPersistence.getValue(IdPersistence.CoopPreviousLevel, Number.MAX_VALUE);
    var maxCoopLevel = selectCoopMaxLevel();
    var level = res.coop && res.coop.xp ? selectCoopLevelFromXp(res.coop.xp) : 0;
    var isOwnCoop = res.coop !== undefined && res.coop.id !== undefined && coopId && res.coop.id.equals(coopId);
    if ((storedLevel > maxCoopLevel || storedLevel <= 0) && isOwnCoop && level > 0) {
        actions.push(actionServerPersistenceSetInfo({
            key: IdPersistence.CoopPreviousLevel,
            platform: PlayerPreferencesPlatformType.PLAT_SHARED,
            value: level.toString(),
        }));
    }
    return from(actions);
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/network/handlers/networkNoticeCoopInfoHandler.ts
// module id = 826
// module chunks = 3